import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitomahabaleshwarcab() {



  const cardData =
  {
    keyword: 'Mumbai to Mahabaleshwar Cab  ',
    heading: 'Shambhu Cabs: Mumbai to Mahabaleshwar Cab ',
    headingDescription: 'Shambhu Cabs offers reliable Mumbai to Mahabaleshwar Cab services, ensuring a safe, comfortable, and scenic journey for families, friends, corporate travelers, and weekend getaway groups. Our fleet of hatchbacks, sedans, SUVs, and tempo travellers is well-maintained to provide a smooth and enjoyable travel experience from Mumbai to the hill station of Mahabaleshwar. With flexible one-way and round-trip options, experienced chauffeurs, and 24/7 booking support, Shambhu Cabs makes your trip stress-free and convenient. From South Mumbai to Thane, Andheri to Vashi, Shambhu Cabs provides doorstep pickup and dependable Mumbai to Mahabaleshwar cab services for all travelers seeking comfort, safety, and reliability.',

    top: 'Top Places to Visit in Mahabaleshwar with Shambhu Cabs',

 "topPlaces": [
  {
    "title": "Arthur’s Seat",
    "description": "Arthur’s Seat — often called the “Queen of All Points” — is Mahabaleshwar’s most famous viewpoint. It offers panoramic views of the deep Savitri River gorge, green valleys, and Sahyadri mountains. On clear days you can see dramatic contrast between lush and barren valley sides; the spot is also known for a floating‑rock phenomenon where light objects thrown into the valley seem to float or drift slowly. Arthur’s Seat is a must for breathtaking vistas and spectacular photos."
  },
  {
    "title": "Venna Lake",
    "description": "Venna Lake is a charming artificial lake built during the British era, now a popular recreational spot for boating (paddle or row boats), lakeside strolls and evening relaxation. Surrounded by trees and hills, it’s ideal for couples and families — you’ll often find corn‑on‑the‑cob vendors, strawberries with cream, and a cool, calm ambience at sunset. Venna Lake blends tranquility and leisure, making it a favourite for tourists visiting Mahabaleshwar."
  },
  {
    "title": "Elephant’s Head Point",
    "description": "Elephant’s Head Point — also called Needle‑Hole Point — is a natural rock formation resembling an elephant’s trunk and head, perched atop the hills. It offers sweeping views of the Sahyadri ranges, deep valleys and distant landscapes. The viewpoint becomes especially magical during monsoon or misty mornings, making it a perfect spot for nature lovers and photographers seeking calm scenic beauty."
  },
  {
    "title": "Wilson Point (Sunrise Point)",
    "description": "Wilson Point is the highest point in Mahabaleshwar (about 1,438 m above sea level) and the only place in the region from where you can catch both sunrise and sunset. With three watch‑towers overlooking hills, valleys and the distant Konkan plain, it’s especially popular among early risers for breathtaking dawn views and panoramic landscapes. Wilson Point is ideal for serene mornings, cool air and far‑reaching vistas."
  },
  {
    "title": "Mapro Garden & Strawberry Farms",
    "description": "Around Mahabaleshwar (near Gureghar / Panchgani) lies :contentReference[oaicite:1]{index=1} — a delightful garden, strawberry farm and food‑product hub famous for fresh strawberries, strawberry shakes, ice creams, jams, syrups and more. It’s a fun outing for families and food lovers; you can walk through plantations, enjoy strawberry‑based treats, and shop for local produce. Mapro’s connection with Mahabaleshwar’s strawberry legacy makes this a must‑visit for a delicious and relaxed day out."
  },
  {
    "title": "Pratapgad Fort",
    "description": "Pratapgad Fort — located approximately 24 km from Mahabaleshwar — is a historical hill‑fort built in 1656. It is famous for the legendary 1659 battle between Chatrapati Shivaji Maharaj and Afzal Khan. From the fort you get expansive views of the Western Ghats and Konkan region, making it a beautiful blend of history, heritage and scenic hills. Visiting Pratapgad gives a deeper sense of Maharashtra’s Maratha‑era legacy along with a nice day‑trip outside Mahabaleshwar."
  },
  {
    "title": "Lingmala Waterfall",
    "description": "Lingmala Waterfall — nestled amidst dense forest and hills near Mahabaleshwar — becomes especially majestic during the monsoon, with water gushing down from heights and lush greenery all around. The waterfall offers a refreshing break from city heat, and the trek through forest adds a bit of adventure too. For those visiting in rainy or post‑monsoon season, Lingmala makes for a peaceful yet thrilling nature escape."
  },
  {
    "title": "Old Mahabaleshwar & Temple (Panchganga / Mahadeo Temple)",
    "description": "Old Mahabaleshwar — with its ancient temples including the old Hemadpanti‑style Mahadeo (or Panchganga) Temple — is the historic and spiritual heart of the town. According to tradition, this is the source of five rivers: Krishna River, Koyna River, Venna River, Savitri River and Gayatri River — making it a revered pilgrimage site. This area combines scenic beauty, cultural depth and spiritual calm, offering a different side of Mahabaleshwar beyond viewpoints and tourism bustle."
  }
],


 "services": [
  {
    "name": "Mumbai to Mahabaleshwar Taxi",
    "description": "Mumbai to Mahabaleshwar Taxi offers a premium long-distance travel experience for tourists, families, and business travelers heading to the scenic hill station of Mahabaleshwar. This service ensures comfortable seating, smooth rides, and well-maintained vehicles driven by professional chauffeurs who know the route thoroughly. Travelers enjoy doorstep pickup, flexible scheduling, and complete safety throughout the journey. Whether it's a holiday trip, weekend getaway, or a business visit, this taxi service guarantees a hassle-free travel experience with timely drop-offs and personalized travel support."
  },
  {
    "name": "Mahabaleshwar Cab from Mumbai",
    "description": "Mahabaleshwar Cab from Mumbai is ideal for travelers seeking a convenient and reliable ride to the popular hill destination. The service includes a range of cab options such as sedans, SUVs, and premium vehicles tailored to different travel needs. Passengers can expect trained drivers who manage mountain routes efficiently, ensuring a smooth and safe climb towards Mahabaleshwar. With transparent pricing, flexible booking choices, and a focus on customer comfort, this service is perfect for families, corporate groups, or leisure seekers planning a refreshing escape from Mumbai."
  },
  {
    "name": "Mumbai Mahabaleshwar Car Hire",
    "description": "Mumbai Mahabaleshwar Car Hire provides personalized and flexible car rental solutions for travelers heading to Mahabaleshwar. With options ranging from budget-friendly vehicles to luxury cars, customers can choose a model that suits their comfort and budget preferences. Each journey is supported by experienced drivers who are well-versed with long-distance routes, ghats, and hill roads. This service is ideal for tourists who want a private travel experience with complete peace of mind, offering spacious seating, quick booking, and 24/7 customer support."
  },
  {
    "name": "Mumbai to Mahabaleshwar Outstation Cab",
    "description": "Mumbai to Mahabaleshwar Outstation Cab is designed for customers looking for a smooth outstation travel experience. Whether planning a vacation, a weekend retreat, or a family trip, the service provides clean vehicles, courteous drivers, and on-time pickups. The outstation cab service emphasizes comfort over long distances, ensuring adequate breaks, safe driving practices, and route flexibility. The booking process is simple and efficient, offering customers a reliable mode of transport to the picturesque hill station of Mahabaleshwar."
  },
  {
    "name": "Mahabaleshwar Sedan Cab from Mumbai",
    "description": "Mahabaleshwar Sedan Cab from Mumbai offers an economical yet highly comfortable travel experience for small families and couples. Sedans are known for their smooth riding quality, spacious cabins, and fuel efficiency, making them ideal for the Mumbai–Mahabaleshwar journey. Professional chauffeurs ensure safe driving across highways and curved hill roads, providing a stress-free travel experience. This service is particularly suitable for travelers seeking comfort at a budget-friendly price without compromising on reliability and safety."
  },
  {
    "name": "Mumbai to Mahabaleshwar SUV Cab",
    "description": "Mumbai to Mahabaleshwar SUV Cab is perfect for large families, groups, or travelers who require extra space and comfort. Equipped with powerful engines and advanced safety features, SUVs handle long-distance routes and steep ghats with ease. The service includes experienced drivers familiar with mountain driving and flexible travel schedules to match customer preferences. This cab option ensures a premium travel experience with superior legroom, luggage capacity, and smooth navigation along scenic roads leading to Mahabaleshwar."
  },
  {
    "name": "Mumbai Mahabaleshwar One Way Cab",
    "description": "Mumbai Mahabaleshwar One Way Cab is an affordable travel solution for passengers needing a single drop at Mahabaleshwar. This service eliminates return charges, making it cost-effective for guests staying in Mahabaleshwar for extended vacations or relocations. Travelers can choose from sedans, SUVs, and executive vehicles according to their budget and comfort needs. With punctual drivers, safe travel practices, and transparent pricing, this one-way cab is a dependable choice for seamless long-distance travel."
  },
  {
    "name": "Mahabaleshwar Cab Booking Mumbai",
    "description": "Mahabaleshwar Cab Booking Mumbai provides a fast and hassle-free reservation system with instant confirmations and multiple vehicle options. Customers can choose from economy cars, luxury sedans, SUVs, and premium models for a tailored travel experience. The service highlights user convenience with flexible timing, doorstep pickup, secure payments, and 24/7 assistance. Ideal for tourists planning a hill-station vacation, this booking service ensures comfort, professionalism, and complete satisfaction."
  },
  {
    "name": "Affordable Mahabaleshwar Cab Mumbai",
    "description": "Affordable Mahabaleshwar Cab Mumbai offers budget-friendly cab solutions without compromising on safety or comfort. Perfect for solo travelers, families, and students, the service includes clean vehicles, trained drivers, and transparent fare structures. Customers can expect a smooth highway journey, comfortable seating, and reliable service throughout the trip. This travel option is ideal for those looking for value-for-money transportation to Mahabaleshwar without hidden charges or last-minute price changes."
  },
  {
    "name": "Executive Cab to Mahabaleshwar from Mumbai",
    "description": "Executive Cab to Mahabaleshwar from Mumbai is tailored for corporate travelers, luxury travel enthusiasts, and those seeking a premium cab experience. The service features high-end vehicles such as luxury sedans and executive SUVs equipped with superior comfort, advanced amenities, and ample space. Professional chauffeurs ensure a polished journey experience with punctual service, smooth driving, and complete privacy. Ideal for business trips, VIP travelers, and special occasions, this executive cab ensures a high-class travel experience."
  },
  {
    "name": "Mumbai to Mahabaleshwar Shuttle",
    "description": "Mumbai to Mahabaleshwar Shuttle service offers cost-effective shared or group travel options for tourists heading to the popular hill station. This service provides comfortable seating, scheduled departures, and professional drivers, making it ideal for budget travelers or groups wanting a shared ride. The shuttle ensures safety, timely travel, and an enjoyable journey through scenic routes, making it a convenient travel solution for weekend trips and holiday getaways."
  },
  {
    "name": "Corporate Cab Mumbai Mahabaleshwar",
    "description": "Corporate Cab Mumbai Mahabaleshwar service is designed for business travelers who need punctual, executive-level transport for meetings, conferences, or corporate retreats in Mahabaleshwar. The service includes professional chauffeurs trained in corporate etiquette, high-quality vehicles, and flexible booking options. With a focus on safety, comfort, and timely travel, this service caters to business groups and executives seeking premium intercity cab services."
  },
  {
    "name": "Mumbai to Mahabaleshwar Airport Cab",
    "description": "Mumbai to Mahabaleshwar Airport Cab provides a seamless travel experience directly from Mumbai Airport to Mahabaleshwar. Travelers benefit from flight tracking, timely pickups, and smooth long-distance travel with trained drivers. This service is ideal for tourists arriving from other states or countries who want a direct, comfortable transfer to Mahabaleshwar without navigating multiple travel modes."
  },
  {
    "name": "Mahabaleshwar Travel Cab Mumbai",
    "description": "Mahabaleshwar Travel Cab Mumbai offers end-to-end travel support for tourists planning sightseeing or extended stays in Mahabaleshwar. The service includes flexible rental durations, customized itineraries, and experienced drivers familiar with all major tourist attractions such as Venna Lake, Mapro Garden, and Pratapgarh Fort. This makes it ideal for families, groups, and leisure travelers wanting a complete travel package."
  },
  {
    "name": "Mumbai Mahabaleshwar Round Trip Cab",
    "description": "Mumbai Mahabaleshwar Round Trip Cab is perfect for travelers who plan to return to Mumbai after exploring Mahabaleshwar. This service includes round-trip pricing, reliable scheduling, and comfortable vehicles for both legs of the journey. Passengers benefit from professional chauffeurs, flexible return timings, and a smooth travel experience, making it ideal for weekend vacations, family trips, and group travel."
  }
],

"tableData": [
  ["Mumbai to Mahabaleshwar Taxi", "Mahabaleshwar Cab from Mumbai"],
  ["Mumbai Mahabaleshwar Car Hire", "Mumbai to Mahabaleshwar Outstation Cab"],
  ["Mahabaleshwar Sedan Cab from Mumbai", "Mumbai to Mahabaleshwar SUV Cab"],
  ["Mumbai Mahabaleshwar One Way Cab", "Mahabaleshwar Cab Booking Mumbai"],
  ["Affordable Mahabaleshwar Cab Mumbai", "Executive Cab to Mahabaleshwar from Mumbai"],
  ["Mumbai to Mahabaleshwar Shuttle", "Corporate Cab Mumbai Mahabaleshwar"],
  ["Mumbai to Mahabaleshwar Airport Cab", "Mahabaleshwar Travel Cab Mumbai"],
  ["Mumbai Mahabaleshwar Round Trip Cab", "—"]
],




"whychoose": [
  {
    "WhyChooseheading": "Mumbai to Mahabaleshwar Cab with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs offers reliable Mumbai to Mahabaleshwar cab services, perfect for scenic hill-station getaways, family trips, and comfortable long-distance travel."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in spacious, air-conditioned cabs that are regularly maintained to ensure a smooth and relaxing journey to Mahabaleshwar."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Ghats and Hill Routes",
    "WhyChoosedescription": "Our skilled drivers are well-versed with the Mumbai to Mahabaleshwar ghat routes, ensuring safe, smooth, and timely travel."
  },
  {
    "WhyChooseheading": "Transparent and Honest Pricing",
    "WhyChoosedescription": "Enjoy upfront and clear pricing with no hidden charges—fuel, tolls, and driver allowances included for your Mumbai to Mahabaleshwar cab trip."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to help with bookings, travel queries, and route information."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans for Hill-Station Travel",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customizable rental plans to suit your Mumbai to Mahabaleshwar travel requirements."
  },
  {
    "WhyChooseheading": "Sanitized and Safe Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We ensure punctual pickups and smooth service, making your Mumbai to Mahabaleshwar journey convenient and stress-free."
  }
]














  }

const faqData = [
  {
    question: 'Does Shambhu Cabs offer Mumbai to Mahabaleshwar cab services?',
    answer: 'Yes, Shambhu Cabs provides comfortable and reliable Mumbai to Mahabaleshwar cab services with professional drivers.',
  },
  {
    question: 'How can I book a Mumbai to Mahabaleshwar cab with Shambhu Cabs?',
    answer: 'You can easily book through our website, mobile app, or by contacting our 24x7 customer support team.',
  },
  {
    question: 'What types of vehicles are available for Mumbai to Mahabaleshwar cab bookings?',
    answer: 'Shambhu Cabs offers a variety of well-maintained sedans, SUVs, and luxury cars ideal for long-distance travel to Mahabaleshwar.',
  },
  {
    question: 'Are drivers experienced for the Mumbai to Mahabaleshwar route?',
    answer: 'Yes, all our drivers are licensed, experienced, and familiar with the Mumbai to Mahabaleshwar route to ensure a safe journey.',
  },
  {
    question: 'Can I choose custom pickup and drop-off locations for my Mumbai to Mahabaleshwar ride?',
    answer: 'Absolutely. You can select your preferred pickup location in Mumbai and drop-off point anywhere in Mahabaleshwar.',
  },
  {
    question: 'Is Mumbai to Mahabaleshwar cab service available 24x7 with Shambhu Cabs?',
    answer: 'Yes, Shambhu Cabs offers round-the-clock cab booking services for Mumbai to Mahabaleshwar.',
  },
  {
    question: 'Are safety and hygiene protocols followed for Mumbai to Mahabaleshwar cabs?',
    answer: 'All vehicles undergo regular sanitization, and our drivers follow strict safety and hygiene measures for passenger safety.',
  },
  {
    question: 'What payment options are available for Mumbai to Mahabaleshwar cab bookings?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate account payments.',
  },
  {
    question: 'Is customer support available during the Mumbai to Mahabaleshwar journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your trip to assist with any queries or needs.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sandeep Jadhav',
    feedback: 'Our Mumbai to Mahabaleshwar trip with Shambhu Cabs was extremely smooth and comfortable. Highly recommended!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Neha Patankar',
    feedback: 'Shambhu Cabs provided a reliable and safe ride to Mahabaleshwar. Excellent service and polite driver!',
    rating: 5,
  },
];









































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Mahabaleshwar Cab",
  "image": "https://www.shambhucab.com/assets/images/mumbai-to-mahabaleshwar-cab.jpg",
  "description": "Book reliable and comfortable Mumbai to Mahabaleshwar cab services with Shambhu Cabs. Offering safe, affordable, and professional taxi options including sedans, SUVs, and premium cars. Perfect for family trips, corporate travel, one-way and round-trip journeys from Mumbai to Mahabaleshwar.",
  "brand": {
    "@type": "Brand",
    "name": "Shambhu Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5300",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "3500",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/mumbai-to-mahabaleshwar-cab"
  }
};







  return (
    <div>
<Helmet>
  <title>Mumbai to Mahabaleshwar Cab | Affordable & Safe Taxi Service | Shambhu Cabs</title>

  <meta
    name="description"
    content="Book Mumbai to Mahabaleshwar cab service with Shambhu Cabs. Affordable taxi options including sedans and SUVs for one-way and round-trip travel. Safe drivers, clean cars, and reliable service for Mahabaleshwar trips from Mumbai."
  />

  <meta
    name="keywords"
    content="Mumbai to Mahabaleshwar Taxi, Mahabaleshwar Cab from Mumbai, Mumbai Mahabaleshwar Car Hire, Mumbai to Mahabaleshwar Outstation Cab, Mahabaleshwar Sedan Cab from Mumbai, Mumbai to Mahabaleshwar SUV Cab, Mumbai Mahabaleshwar One Way Cab, Mahabaleshwar Cab Booking Mumbai, Affordable Mahabaleshwar Cab Mumbai, Executive Cab to Mahabaleshwar from Mumbai, Mumbai to Mahabaleshwar Shuttle, Corporate Cab Mumbai Mahabaleshwar, Mumbai to Mahabaleshwar Airport Cab, Mahabaleshwar Travel Cab Mumbai, Mumbai Mahabaleshwar Round Trip Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/75.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitomahabaleshwarcab;